import { FC, useContext, useEffect, useState } from "react";
import { InsuranceInformation as InsuranceInformationType, InsuranceInformationProps } from "./type";
import { formatPhoneNumber } from "src/helpers";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { ToastTypes } from "src/types";
import { ToastContext } from "src/context/toastContext";

const InsuranceInformation: FC<InsuranceInformationProps> = ({ caseId, insuranceInformation, insuranceNumber }): JSX.Element => {
  const [precertPathParameters] = useState<{ caseId: number; precertId: number }>({ caseId: 0, precertId: 0 })
  const { isManufacturer } = useContext(AuthContext)
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext)



  const { data: fetchPrecertResponse } =
    useFetch<{ code: number; message: string; }>(APIEndpoints.FETCH_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse)
      navigate(`/cases/${precertPathParameters && precertPathParameters.caseId}/precerts/${precertPathParameters && precertPathParameters.precertId}/edit`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  // const navigateToPrecertForm = (caseId: number, precertId: number) => {
  //   const pathParams = {
  //     case_id: caseId,
  //     id: precertId
  //   }
  //   setPrecertPathParameters({ caseId, precertId })
  //   fetchPrecertMutate({}, pathParams)
  // }

  const precertCheck = (item: InsuranceInformationType) => {
    if (item.precert_present && item.precert_editable) {
      return (
        <button
          className="btn btn-warning btn-sm m-1 text-white"
          onClick={() => showToast(["Precert not found!"], ToastTypes.ERROR)}
        >
          <i className="fas fa-clipboard-list me-2"></i> Precert
        </button>
      )
    }
    else {
      return <p className="text-black">{item.precert}</p>
    }
  }

  return (
    <div className={`card rounded-1 ${insuranceNumber > 1 ? 'mt-3' : ''}`}>
      <div className="card-header bg-success-subtle">
        <h5 className="mb-0 text-black text-center">
          Insurance # {insuranceNumber}: {insuranceInformation ? insuranceInformation.insurance_priority : 'N/A'}
        </h5>
      </div>

      <div className="card-body">
        <div className="row">

          <div className="col-12 col-md-6">
            {!isManufacturer && <div className="row">
              <div className="col-6 text-end">
                <p>Relation to Patient:</p>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.relation_to_patient : 'N/A'}
                </p>
              </div>
            </div>}
          </div>

          {insuranceInformation && insuranceInformation.relation_to_patient !== "Self" ? (
            <>
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Relation First Name:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_first_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Relation Middle Name:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_middle_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Relation Last Name:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.relation_last_name : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : <div className="col-6"></div>}
          <div className="col-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Insurance Name:</p>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.insurance_name : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end">
                <p>Plan Name:</p>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.plan_name : 'N/A'}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end">
                <p>Plan Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {insuranceInformation ? insuranceInformation.plan_type : 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Medical Insurance */}
        <div className="card my-4 rounded-1">
          <div className="card-header bg-success-subtle">
            <h5 className="text-black mb-0">Medical Insurance</h5>
          </div>

          <div className="card-body">
            <div className="row">

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Member ID:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.member_id : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Group:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.group : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Insurance Phone:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation && insuranceInformation.insurance_phone && insuranceInformation.insurance_phone !== 'N/A' ? formatPhoneNumber(insuranceInformation.insurance_phone) : "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Precert:</p>
                  </div>
                  <div className="col-6">
                    {precertCheck(insuranceInformation)}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Pharmacy Insurance */}
        <div className="card my-2 mb-0 rounded-1">
          <div className="card-header bg-success-subtle">
            <h5 className="text-black mb-0">Pharmacy Insurance</h5>
          </div>

          <div className="card-body">
            <div className="row">

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Rx Member ID:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.rx_member_id : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Rx Group:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.rx_group : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>BIN:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.bin : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>PCN:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.pcn : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end">
                    <p>Prior Authorization:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {insuranceInformation ? insuranceInformation.prior_authorization : 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceInformation;